<script lang="ts">
	import TableCell from 'components/Table/TableCell/TableCell.svelte';
	import TableRow from 'components/Table/TableRow/TableRow.svelte';
	import NoIcon from 'assets/svg/noCoinIcon.svg?url';
	import { onErrorCoinLogo } from 'utils/onErrorCoinLogo';
	import formatNumber from 'utils/formatNumber';
	import activeCurrency from 'stores/activeCurrency';
	import getClientWidth from 'utils/getClientWidth';
	import { browser } from '$app/environment';
	import { onMount } from 'svelte';
	import type { ITopMarket } from 'customTypes/exchange';
	import processWalletAdrress from 'utils/processWalletAdrress';
	import formatCoinPrice from 'utils/formatCoinPrice';
	import PriceTooltip from 'components/PriceTooltip/PriceTooltip.svelte';

	export let dark = false;
	export let data: ITopMarket;
	let isMobileView: boolean;

	const { base, target, market_name, volume_usd, price_usd, logo, rank, exchange_name } = data;
	$: pairName =
		market_name.length > 25
			? `${processWalletAdrress(base, 2, true)}/${processWalletAdrress(target, 2, true)}`
			: market_name;

	onMount(() => {
		if (!browser) return;
		calculateViewportWidth();
		window.addEventListener('resize', calculateViewportWidth);
		return () => {
			window.removeEventListener('resize', calculateViewportWidth);
		};
	});

	function calculateViewportWidth() {
		const viewportWidth = getClientWidth();
		isMobileView = viewportWidth < 768;
	}
</script>

<TableRow {dark} class="exchange-market-table-row" withHover={false}>
	<TableCell {dark} class="exchange-market-name">
		<img
			class="exchange-icon"
			src={logo ?? NoIcon}
			alt={`${exchange_name} logo`}
			loading="lazy"
			on:error={onErrorCoinLogo}
		/>
		<div class="market-data">
			<p class="name">{pairName}</p>
			<div class="name-wrapper">
				<p class="market-rank" class:dark>{rank}</p>
				<p class="exchange-name" class:dark>{exchange_name}</p>
			</div>
		</div>
	</TableCell>
	<TableCell {dark} class="exchange-market-price">
		<PriceTooltip
			price={formatCoinPrice(
				formatNumber(
					price_usd * $activeCurrency.price,
					$activeCurrency.currency,
					isMobileView,
					'currency',
				),
			)}
		/>
	</TableCell>
	<TableCell {dark} class="exchange-market-volume">
		{formatNumber(
			volume_usd * $activeCurrency.price,
			$activeCurrency.currency,
			isMobileView,
			'currency',
		)}
	</TableCell>
</TableRow>

<style lang="scss">
	@import 'topMarketsTableRow';
</style>
